import React from 'react';
import classes from './styles/Tabs.scss';

export default ({ children }) => <div className={classes.Tabs__panel}>{children}</div>;
